/**
 * AdminStatsRpcClient - AtomRpc integration for admin dashboard stats
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminStatsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminStatsRpcClient extends AtomRpc.Tag<AdminStatsRpcClient>()(
  "AdminStatsRpcClient",
  {
    group: AdminStatsRpcs,
    protocol: makeRpcClientLayer(AdminStatsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
